"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const Wrapper = styled_components_1.default.div `
  padding: 20px;
  font-size: 1rem;
  text-align: center;
  height: 100%;
  background: #fff;
`;
const NoMatch = () => (react_1.default.createElement(Wrapper, { "data-testid": "no-match" }, i18n_js_1.default.t("page_not_found")));
exports.default = NoMatch;
